/** Two tiers of signal, because they answer different questions. */
const CORE_KINDS = new Set([
    "wearable.sleep",
    "wearable.hrv",
    "wearable.rhr",
    "wearable.activity",
    "calendar.event",
]);
/** No environment reading is core, today's weather included. */
export function snapshotSignalTier(kind) {
    return CORE_KINDS.has(kind) ? "core" : "additive";
}
/** The same kinds, split the two ways the sources page reads them. */
export function splitSnapshotSignalTiers(kinds) {
    const core = [];
    const additive = [];
    for (const kind of kinds) {
        if (snapshotSignalTier(kind) === "core")
            core.push(kind);
        else
            additive.push(kind);
    }
    return { core, additive };
}
//# sourceMappingURL=snapshot-signal-tiers.js.map